(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dn-block"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__dnInit) return; window.__dnInit = true;
  var MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function shipDate(n){var d=new Date(),k=0;while(k<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)k++;}return MON[d.getMonth()]+' '+d.getDate();}


  // JSON POST that detects Shopify bot-check / HTML responses
  function jpost(url,body){
    return fetch(url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)})
      .then(function(r){return r.text().then(function(t){var d;try{d=JSON.parse(t)}catch(_){var e=new Error('blocked');e.blocked=true;throw e;}
        if(!r.ok){throw new Error(d.description||d.message||'Could not add to cart');} return d;});});
  }
  // fallback: normal form post (works even when AJAX is challenged)
  function formAdd(item,ret){
    var f=document.createElement('form');f.method='post';f.action='/cart/add';
    var add=function(n,v){var i=document.createElement('input');i.type='hidden';i.name=n;i.value=v;f.appendChild(i);};
    add('id',item.id);add('quantity',item.quantity||1);if(item.selling_plan)add('selling_plan',item.selling_plan);add('return_to',ret);
    document.body.appendChild(f);f.submit();
  }
  var DN=window.DN=window.DN||{};
  // ---------- cart drawer ----------
  DN.cart=(function(){
    var el,body,foot,cur='USD',cfg={};
    function money(c){try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:cur}).format(c/100)}catch(_){return '$'+(c/100).toFixed(2)}}
    function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]})}
    function build(){
      if(el) return; var src=document.querySelector('[data-dn-cart-cfg]'); cfg=src?JSON.parse(src.textContent):{};
      el=document.createElement('div'); el.className='dn-cd dn'; el.setAttribute('aria-hidden','true');
      el.style.setProperty('--acc',cfg.acc||'#d8b08c');
      el.innerHTML='<div class="dn-cd__ov" data-x></div><aside class="dn-cd__p" role="dialog" aria-label="Cart"><header class="dn-cd__h"><h2>'+esc(cfg.title||'Cart')+' <span data-n></span></h2><button type="button" class="dn-cd__x" data-x aria-label="Close">&times;</button></header>'
        +(cfg.note?'<div class="dn-cd__note">'+esc(cfg.note)+'</div>':'')
        +'<div class="dn-cd__b" data-b></div><footer class="dn-cd__f" data-f></footer></aside>';
      document.body.appendChild(el); body=el.querySelector('[data-b]'); foot=el.querySelector('[data-f]');
      el.addEventListener('click',function(e){
        if(e.target.closest('[data-x]')){close();return;}
        var q=e.target.closest('[data-q]'); if(q){change(+q.dataset.line,+q.dataset.q);return;}
      });
      document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});el.addEventListener('change',function(e){var sw=e.target.closest('[data-prot]');if(!sw||!cfg.prot)return;el.classList.add('is-busy');var pid=cfg.prot.id;var p=sw.checked?jpost('/cart/add.js',{items:[{id:pid,quantity:1}]}).then(load):fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){var l=-1;c.items.forEach(function(it,i){if(it.variant_id===pid)l=i+1;});return l>0?jpost('/cart/change.js',{line:l,quantity:0}).then(render):render(c);});p.catch(function(){load();}).then(function(){el.classList.remove('is-busy')});});
    }
    function render(c){
      cur=c.currency||cur; el.querySelector('[data-n]').textContent='• '+c.item_count+' item'+(c.item_count===1?'':'s');
      var cmpMap=cfg.cmp||{}, save=0;
      if(!c.items.length){body.innerHTML='<p class="dn-cd__empty">Your cart is empty.</p>';foot.innerHTML='';return;}
      var P=cfg.prot,pl=-1,pi=null;c.items.forEach(function(it,i){if(P&&it.variant_id===P.id){pl=i+1;pi=it;}});if(pi){var nn=c.item_count-pi.quantity;el.querySelector('[data-n]').textContent='• '+nn+' item'+(nn===1?'':'s');}if(pi&&c.items.length===1){change(pl,0);return;}if(pi&&pi.quantity>1){change(pl,1);return;}body.innerHTML=c.items.map(function(it,i){if(P&&it.variant_id===P.id)return '';
        var spa=it.selling_plan_allocation, unitCmp=Math.max(+(cmpMap[it.variant_id]||0), spa&&spa.compare_at_price||0, it.original_price||0);
        var lineCmp=unitCmp*it.quantity; if(lineCmp>it.final_line_price) save+=lineCmp-it.final_line_price;
        var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):'';
        return '<div class="dn-cd__it">'+(img?'<img src="'+esc(img)+'" alt="">':'<span class="dn-cd__ph"></span>')
          +'<div class="dn-cd__i"><div class="dn-cd__t"><b>'+esc(it.product_title)+'</b><button type="button" class="dn-cd__rm" data-q="0" data-line="'+(i+1)+'" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button></div>'
          +'<div class="dn-cd__pr">'+(unitCmp>it.final_price?'<s>'+money(unitCmp)+'</s>':'')+'<b>'+money(it.final_price)+'</b>'+(it.variant_title?'<span class="dn-cd__tag">'+esc(it.variant_title)+'</span>':'')+'</div>'
          +(spa?'<div class="dn-cd__sp">'+esc(spa.selling_plan.name)+'</div>':'')
          +'<div class="dn-cd__row"><div class="dn-cd__qty"><button type="button" data-q="'+(it.quantity-1)+'" data-line="'+(i+1)+'" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" data-line="'+(i+1)+'" aria-label="Increase">+</button></div>'
          +'<div class="dn-cd__lp">'+(lineCmp>it.final_line_price?'<s>'+money(lineCmp)+'</s>':'')+'<b>'+money(it.final_line_price)+'</b></div></div></div></div>';
      }).join('');
      var pay=document.querySelector('[data-dn-pay]');
      foot.innerHTML=(P?'<label class="dn-cd__prot"><span class="dn-cd__pi">'+(P.img?'<img src="'+esc(P.img)+'" alt="">':'<svg viewBox="0 0 48 48" width="40" height="40"><path d="M24 4 8 10v12c0 10.5 6.8 19.2 16 22 9.2-2.8 16-11.5 16-22V10L24 4z" fill="#d8b08c"/><path d="m17 24 5 5 9-10" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')+'</span><span class="dn-cd__pt"><b>'+esc(P.title)+'</b><small>'+esc(P.text)+'</small></span><span class="dn-cd__pp">'+money(P.price)+'</span><input type="checkbox" class="dn-cd__sw" data-prot'+(pi?' checked':'')+' aria-label="'+esc(P.title)+'"></label>':'')+(save>0?'<div class="dn-cd__sum"><span>'+esc(cfg.save_l||'Savings')+'</span><span>-'+money(save)+'</span></div>':'')
        +'<div class="dn-cd__sum dn-cd__tot"><span>'+esc(cfg.sub_l||'Subtotal')+'</span><span>'+money(c.total_price)+'</span></div>'
        +(cfg.ship?'<p class="dn-cd__ship">'+esc(cfg.ship)+'</p>':'')
        +'<a class="dn-cd__go" href="/checkout">'+esc(cfg.btn||'Checkout')+' • '+money(c.total_price)+'</a>'+(cfg.trust?'<div class="dn-cd__trust"><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>Tracked shipping</span><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v9M14.6 9.6c-.4-.8-1.4-1.3-2.6-1.3-1.5 0-2.6.8-2.6 1.9 0 2.6 5.3 1.4 5.3 4 0 1.1-1.2 1.9-2.7 1.9-1.3 0-2.3-.5-2.7-1.4"/></svg>30-day guarantee</span><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>Secure checkout</span></div>':'')
        +(pay?'<div class="dn-pay dn-cd__pay">'+pay.innerHTML+'</div>':'')+'<button type="button" class="dn-cd__cont" data-x>Continue shopping</button>';
    }
    function load(){return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(render);}
    function change(line,q){el.classList.add('is-busy');jpost('/cart/change.js',{line:line,quantity:Math.max(0,q)}).then(render).catch(function(e){if(e.blocked)location.href='/cart';}).then(function(){el.classList.remove('is-busy')});}
    function open(){build();load().then(function(){el.classList.add('is-on');el.setAttribute('aria-hidden','false');document.documentElement.classList.add('dn-lock');});}
    function close(){if(!el)return;el.classList.remove('is-on');el.setAttribute('aria-hidden','true');document.documentElement.classList.remove('dn-lock');}
    return {open:open,close:close};
  })();

  function initAll(root){
    root=root||document;
    // ship-by text: "{date}" -> real business-day estimate
    root.querySelectorAll('[data-ship]').forEach(function(el){
      if(!el.dataset.tpl) el.dataset.tpl=el.textContent;
      el.textContent=el.dataset.tpl.replace('{date}',shipDate(parseInt(el.dataset.ship||'0',10)));
    });
    // countdown to a real end date set in the editor
    root.querySelectorAll('.dn-top[data-end]').forEach(function(el){
      var end=Date.parse((el.dataset.end||'').replace(' ','T')); var cd=el.querySelector('.dn-top__cd');
      if(!end||!cd) return;
      function tick(){var ms=end-Date.now(); if(ms<=0){cd.hidden=true;return;} cd.hidden=false;
        var s=Math.floor(ms/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),x=s%60;
        cd.textContent=(d?d+'d ':'')+[h,m,x].map(function(v){return v<10?'0'+v:v}).join(':');}
      tick(); clearInterval(el._t); el._t=setInterval(tick,1000);
    });
    // before/after
    root.querySelectorAll('[data-ba]').forEach(function(b){var r=b.querySelector('input');if(!r||r._ok)return;r._ok=1;r.addEventListener('input',function(){b.style.setProperty('--x',r.value+'%')});});
    // gallery
    root.querySelectorAll('[data-gal]').forEach(function(g){
      if(g._ok) return; g._ok=1;
      var tr=g.querySelector('[data-track]'), th=[].slice.call(g.querySelectorAll('.dn-gal__th'));
      function idx(){return Math.round(tr.scrollLeft/tr.clientWidth)}
      function go(i){var n=tr.children.length; i=(i+n)%n; tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});}
      function mark(){var i=idx(); th.forEach(function(b,j){b.classList.toggle('is-on',j===i)});}
      g.querySelector('[data-prev]').onclick=function(){go(idx()-1)};
      g.querySelector('[data-next]').onclick=function(){go(idx()+1)};
      th.forEach(function(b,j){b.onclick=function(){go(j)}});
      tr.addEventListener('scroll',function(){clearTimeout(tr._s);tr._s=setTimeout(mark,80)}); mark();
      if(tr.children.length<2) g.querySelectorAll('.dn-gal__arr').forEach(function(a){a.style.display='none'});
    });
    // show more
    root.querySelectorAll('[data-more]').forEach(function(box){
      var n=parseInt(box.dataset.more||'0',10); if(!n) return;
      var items=[].slice.call(box.children); if(items.length<=n) return;
      var btn=box.parentNode.querySelector('[data-morebtn]');
      if(window.Shopify&&Shopify.designMode) return;
      items.forEach(function(it,i){if(i>=n) it.classList.add('is-hid')});
      if(btn) btn.onclick=function(){items.forEach(function(it){it.classList.remove('is-hid')});btn.remove();};
    });
    // packages -> add to cart
    root.querySelectorAll('[data-pk]').forEach(function(pk){
      var sec=pk.closest('.dn'); var btn=sec.querySelector('[data-buy]'); var err=sec.querySelector('[data-err]');
      if(!btn||btn._ok) return; btn._ok=1;
      if(!pk.querySelector('input:checked')){var f=pk.querySelector('input:not([disabled])'); if(f) f.checked=true;}
      var tg=sec.querySelector('[data-toggle]'), sn=sec.querySelector('[data-subnote]');
      function paint(){
        var sub=pk.dataset.mode==='sub';
        pk.querySelectorAll('.dn-pk__opt').forEach(function(o){
          var p=o.querySelector('[data-p]'),c=o.querySelector('[data-c]'),t=o.querySelector('[data-t]');
          if(p) p.textContent=sub?o.dataset.ps:o.dataset.po; if(c) c.textContent=sub?o.dataset.cs:o.dataset.co; if(t) t.textContent=sub?o.dataset.ts:o.dataset.to;
        });
        if(tg){var ch=pk.querySelector('input:checked'),o=ch&&ch.closest('.dn-pk__opt');
          tg.innerHTML=sub?(tg.dataset.once+' \u2022 <span>'+(o?o.dataset.po:'')+'</span>'):(tg.dataset.subt+' \u2022 <span>'+(o?o.dataset.ps:'')+'</span>');}
        if(sn) sn.hidden=!sub;
      }
      if(tg){tg.addEventListener('click',function(){pk.dataset.mode=pk.dataset.mode==='sub'?'once':'sub';paint();});}
      pk.addEventListener('change',paint); paint();
      btn.addEventListener('click',function(){
        var r=pk.querySelector('input:checked'); if(!r||!r.value){err.hidden=false;err.textContent='Please choose a package.';return;}
        btn.disabled=true; err.hidden=true;
        var opt=r.closest('.dn-pk__opt'); var item={id:parseInt(r.value,10),quantity:1};
        if(pk.dataset.mode==='sub'&&opt.dataset.sp) item.selling_plan=parseInt(opt.dataset.sp,10);
        var after=pk.dataset.after||'drawer';
        var clear=(after!=='drawer'&&pk.dataset.clear==='true')?jpost('/cart/clear.js',{}):Promise.resolve();
        clear.then(function(){return jpost('/cart/add.js',{items:[item]});})
        .then(function(){
          if(after==='drawer'){btn.disabled=false; DN.cart.open();}
          else location.href=after==='cart'?'/cart':'/checkout';
        })
        .catch(function(e){
          btn.disabled=false;
          if(e&&e.blocked){formAdd(item, after==='checkout'?'/checkout':'/cart');return;}
          err.hidden=false; err.textContent=(e&&e.message)||'Something went wrong. Please try again.';
        });
      });
    });
    // sticky CTA: visible after first hero, hidden while an offer section is on screen
    var st=document.querySelector('[data-sticky]');
    if(st&&!st._ok&&'IntersectionObserver' in window){
      st._ok=1; var past=false, offerOn=false;
      var hero=document.querySelector('.dn--hero'); var offers=document.querySelectorAll('.dn--offer');
      function upd(){st.classList.toggle('is-on',past&&!offerOn)}
      if(hero) new IntersectionObserver(function(es){es.forEach(function(e){past=!e.isIntersecting&&e.boundingClientRect.top<0;});upd();}).observe(hero); else {past=true;upd();}
      var vis=new Set();
      offers.forEach(function(o){new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?vis.add(o):vis.delete(o)});offerOn=vis.size>0;upd();},{threshold:.15}).observe(o)});
    }
  }
  // smooth scroll for in-page CTA links
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#"]'); if(!a||!a.closest('.dn')) return;
    var id=a.getAttribute('href').slice(1); var el=id&&document.getElementById(id);
    if(el){e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'start'});}
  });
  if(document.readyState!=='loading') initAll(); else document.addEventListener('DOMContentLoaded',function(){initAll()});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
